import { render, staticRenderFns } from "./office-view.vue?vue&type=template&id=74558b5e&"
import script from "./office-view.vue?vue&type=script&lang=js&"
export * from "./office-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports